module.exports = __webpack_public_path__ + "static_pc/img/case1.03dddaf2.png";